import { createSagaActionTypes } from '../../../utils/actionFactory';
export const NEW_SIMCARD_REQUEST = 'NEW_SIMCARD_REQUEST';
export const GET_SELECT_OPTIONS = 'GET_SELECT_OPTIONS';

export const actions = createSagaActionTypes('ORDER_SIMCARD_WIZARD', [
  NEW_SIMCARD_REQUEST,
  GET_SELECT_OPTIONS
]);
